import { takeLatest } from 'redux-saga/effects';
import apiCall, { GRATAFY_URL } from '../../utils/apiCall';
import {
  CLEAR_INTERCOM_USERS,
  DELETE_INTERCOM_USER,
  GET_GRATA_INTERCOM_USER,
  GET_INTERCOM_UNIT_PINS,
  PUSH_RESIDENTS_TO_INTERCOM,
  SEARCH_INTERCOM_USERS,
  UPDATE_INTERCOM_USER
} from '../constants';

const getIntercomUnitPins = apiCall({
  type: GET_INTERCOM_UNIT_PINS,
  method: 'GET',
  path: ({ orgId, buildingId, unitID }) =>
    `/akuvox/orgs/${orgId}/buildings/${buildingId}/units/${unitID}`,
  gratafyURL: GRATAFY_URL
});

const getGrataIntercomUser = apiCall({
  type: GET_GRATA_INTERCOM_USER,
  method: 'GET',
  path: ({ userId }) => `/users/${userId}`
});

const updateIntercomUser = apiCall({
  type: UPDATE_INTERCOM_USER,
  method: 'PATCH',
  path: ({ orgId, buildingId, userId }) =>
    `/akuvox/orgs/${orgId}/buildings/${buildingId}/users/${userId}`,
  gratafyURL: GRATAFY_URL
});

const deleteIntercomUser = apiCall({
  type: DELETE_INTERCOM_USER,
  method: 'DELETE',
  path: ({ orgId, buildingId, userId }) =>
    `/akuvox/orgs/${orgId}/buildings/${buildingId}/users/${userId}`,
  gratafyURL: GRATAFY_URL
});

const searchIntercomUsers = apiCall({
  type: SEARCH_INTERCOM_USERS,
  method: 'GET',
  path: ({ orgId, buildingId, queryString }) =>
    `/akuvox/orgs/${orgId}/buildings/${buildingId}/search${queryString ? `?${queryString}` : ''}`,
  gratafyURL: GRATAFY_URL
});

const clearIntercoms = apiCall({
  type: CLEAR_INTERCOM_USERS,
  method: 'DELETE',
  path: ({ orgId, buildingId }) => `/akuvox/orgs/${orgId}/buildings/${buildingId}/clear`,
  gratafyURL: GRATAFY_URL
});

const pushResidentsToIntercom = apiCall({
  type: PUSH_RESIDENTS_TO_INTERCOM,
  method: 'POST',
  path: ({ orgId, buildingId }) => `/intercom/orgs/${orgId}/buildings/${buildingId}/sync`
});

export default function* akuvoxSaga() {
  yield takeLatest(GET_INTERCOM_UNIT_PINS, getIntercomUnitPins);
  yield takeLatest(GET_GRATA_INTERCOM_USER, getGrataIntercomUser);
  yield takeLatest(UPDATE_INTERCOM_USER, updateIntercomUser);
  yield takeLatest(DELETE_INTERCOM_USER, deleteIntercomUser);
  yield takeLatest(SEARCH_INTERCOM_USERS, searchIntercomUsers);
  yield takeLatest(CLEAR_INTERCOM_USERS, clearIntercoms);
  yield takeLatest(PUSH_RESIDENTS_TO_INTERCOM, pushResidentsToIntercom);
}
